import { Controller } from "@hotwired/stimulus"

// Searchable client filter for the releases boards (the house typeahead
// contract: type to filter a server-rendered scoped list, ArrowUp/Down
// highlight, Enter picks the highlighted or only-visible row, Escape
// closes). Picking sets the hidden client_id and submits the GET filter
// form; the x button clears and resubmits. Purely a filter: the list is
// scoped at render time, which is the authorization guarantee.
export default class extends Controller {
  static targets = ["input", "list", "item", "empty", "clientId", "form", "clear"]

  connect() {
    this.highlighted = -1
  }

  filter() {
    const q = this.inputTarget.value.trim().toLowerCase()
    this.highlighted = -1
    this.inputTarget.setAttribute("aria-expanded", q.length > 0)
    this.listTarget.classList.toggle("hidden", q.length === 0)
    if (q.length === 0) return

    let shown = 0
    this.itemTargets.forEach((el) => {
      const hit = el.dataset.search.includes(q)
      el.classList.toggle("hidden", !hit)
      el.classList.remove("bg-[#F5F3F0]")
      if (hit) shown++
    })
    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", shown > 0)
  }

  keydown(event) {
    const visible = this.itemTargets.filter((el) => !el.classList.contains("hidden"))
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault()
      if (visible.length === 0) return
      const delta = event.key === "ArrowDown" ? 1 : -1
      this.highlighted = Math.min(Math.max(this.highlighted + delta, 0), visible.length - 1)
      visible.forEach((el, i) => {
        el.classList.toggle("bg-[#F5F3F0]", i === this.highlighted)
        el.setAttribute("aria-selected", i === this.highlighted ? "true" : "false")
      })
      if (visible[this.highlighted].id) this.inputTarget.setAttribute("aria-activedescendant", visible[this.highlighted].id)
      visible[this.highlighted].scrollIntoView({ block: "nearest" })
    } else if (event.key === "Enter") {
      event.preventDefault()
      if (this.highlighted >= 0 && visible[this.highlighted]) {
        this.pickItem(visible[this.highlighted])
      } else if (visible.length === 1 && this.inputTarget.value.trim() !== "") {
        this.pickItem(visible[0])
      }
    } else if (event.key === "Escape") {
      this.listTarget.classList.add("hidden")
    }
  }

  pick(event) {
    this.pickItem(event.currentTarget)
  }

  pickItem(item) {
    this.clientIdTarget.value = item.dataset.clientId
    this.inputTarget.value = item.dataset.clientName
    this.listTarget.classList.add("hidden")
    this.formTarget.requestSubmit()
  }

  clear() {
    this.clientIdTarget.value = ""
    this.inputTarget.value = ""
    this.formTarget.requestSubmit()
  }
}
